module.exports = __webpack_public_path__ + "static/media/illo-membership-promo.882808d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/illo-membership-promo.png
// module id = 1328
// module chunks = 1